<template>
  <div class="card category-questions-widget">
    <div class="card-header">
      <h4 class="card-title mx-auto">
        {{ widgetTitle }}
      </h4>
    </div>
    <div class="card-body pb-lg-20">
      <!-- Question info -->
      <CategoryDetailsQuestions :category="category" :fullScreen="true" />
    </div>
  </div>
</template>

<script>
export const categoryQuestionsWidgetInformation = () => {
  return {
    requests: {}
  }
}

export const categoryQuestionsWidgetSkeleton = () => {
  return {
    header: {
      height: 2
    },
    body: [1, 2, 3, 4].map(() => {
      return { cols: [{ height: 2 }, { height: 2 }] }
    })
  }
}

import CategoryDetailsQuestions from '@/components/widgets/categories-bars-widget/subcomponents/CategoryDetailsQuestions.vue'

export default {
  name: 'CategoryQuestionsWidget',
  components: {
    CategoryDetailsQuestions
  },
  props: {
    category: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    widgetTitle() {
      return `${this.$tr(this.category.details.messages, 'title')} - ${this.$localeNumber(this.category.value)}`
    }
  }
}
</script>

<style scoped>
.category-questions-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px 20px;
}
</style>
